// removed by extract-text-webpack-plugin
module.exports = {"icon":"c-SvgIcon__icon","plus":"c-SvgIcon__plus","minus":"c-SvgIcon__minus","checkMark":"c-SvgIcon__checkMark","bag":"c-SvgIcon__bag","arrowLeft":"c-SvgIcon__arrowLeft","arrowRight":"c-SvgIcon__arrowRight","error":"c-SvgIcon__error","success":"c-SvgIcon__success","lock":"c-SvgIcon__lock","information":"c-SvgIcon__information"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SvgIcon/SvgIcon.scss
// module id = 473
// module chunks = 0